
MassMessagingConfirmSendController.$inject = ['$scope', '$mdDialog', '$translate', 'audienceSize'];
export function MassMessagingConfirmSendController($scope, $mdDialog, $translate, audienceSize) {


  $scope.ok = ok;
  $scope.cancel = cancel;    


  init();


  function ok() {
    $mdDialog.hide();
  }


  function cancel() {
    $mdDialog.cancel();
  }


  function init() {
    $scope.confirmText = $translate.instant('mass_messaging/confirm_text', { n: audienceSize });
  }
}
